<div class="breadcrumbs">
  <onsip-header-breadcrumb-container>
    <ng-template onsipBreadcrumb
      ><span class="onsip-breadcrumb-non-link">{{
        "ONSIP_I18N.ADMINISTRATORS" | translate | sentenceCase
      }}</span></ng-template
    >
    <ng-template onsipBreadcrumb
      ><span class="onsip-breadcrumb-non-link">{{
        "ONSIP_I18N.INBOUND_CALL_SETTINGS" | translate
      }}</span></ng-template
    >
    <ng-template onsipBreadcrumb
      ><span [routerLink]="views.ADMIN_ADV_ANNOUNCEMENTS">{{
        "ONSIP_I18N.ANNOUNCEMENTS" | translate
      }}</span></ng-template
    >
  </onsip-header-breadcrumb-container>
</div>
<onsip-header-main>
  <onsip-header-page-title>
    {{ "ONSIP_I18N.ANNOUNCEMENTS" | translate }}
  </onsip-header-page-title>
</onsip-header-main>
<onsip-loading-container [deferCond]="isDataObtained$">
  @if (hasAnnouncements | async) {
  <onsip-header-main>
    <onsip-header-action-bar>
      <mat-form-field appearance="outline">
        <input
          matInput
          [formControl]="search"
          [placeholder]="'ONSIP_I18N.SEARCH' | translate"
          [attr.data-cy]="E2eLocators.ADMIN_ANNOUNCEMENT_SEARCH"
          autocomplete="off"
        />
        <mat-icon matSuffix color="primary">search</mat-icon>
      </mat-form-field>
      <button
        mat-stroked-button
        onsip-header-secondary-action
        color="primary"
        [routerLink]="views.ADMIN_ADV_ANNOUNCEMENTS_SETUP"
        [attr.data-cy]="E2eLocators.ADMIN_ANNOUNCEMENT_ADD_BTN"
      >
        {{ "ONSIP_I18N.ADD_ANNOUNCEMENT" | translate }}
      </button>
    </onsip-header-action-bar>
  </onsip-header-main>
  <onsip-table-two
    class="announcements-table"
    matSort
    multiTemplateDataRows
    [dataSource]="dataSource"
    [trackBy]="trackByAnnouncementId"
    [useGrid]="true"
    [hoverable]="true"
  >
    <!-- NAME -->
    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{
        "ONSIP_I18N.NAME" | translate
      }}</mat-header-cell>
      <mat-cell *matCellDef="let announcement">
        <span class="announcement-cell-content">{{ announcement.name }}</span>
      </mat-cell>
    </ng-container>
    <!-- TRANSFER NAME -->
    <ng-container matColumnDef="transferAddressUsername">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{
        "ONSIP_I18N.TRANSFER_TO" | translate
      }}</mat-header-cell>
      <mat-cell *matCellDef="let announcement">
        <span class="announcement-cell-content">{{ getTransferText(announcement) }}</span>
      </mat-cell>
    </ng-container>
    <!-- ACTIONS -->
    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let announcement" class="actions-cell">
        <mat-icon color="primary" class="expand-button">{{
          selectedRows.includes(announcement.advAnnouncementId) ? "expand_less" : "expand_more"
        }}</mat-icon>
        <button
          mat-icon-button
          (click)="removeItem(announcement, $event)"
          [attr.data-cy]="E2eLocators.ADMIN_ANNOUNCEMENT_REMOVE_BTN"
          color="primary"
          class="delete-button"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </mat-cell>
    </ng-container>
    <!-- SHELF -->
    <ng-container matColumnDef="expanded">
      <onsip-table-shelf-cell
        *matCellDef="let announcement"
        [attr.colspan]="displayedColumns.length"
        [expanded]="selectedRows.includes(announcement.advAnnouncementId)"
      >
        @if (selectedRows.includes(announcement.advAnnouncementId)) {
        <onsip-adv-announcements-shelf-container
          [announcement]="announcement"
          [transferToText]="getTransferText(announcement)"
        >
        </onsip-adv-announcements-shelf-container>
        }
      </onsip-table-shelf-cell>
    </ng-container>
    <!-- ROWS -->
    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row
      *matRowDef="let row; columns: displayedColumns"
      (click)="
        selectedRows.includes(row.advAnnouncementId)
          ? selectedRows.splice(selectedRows.indexOf(row.advAnnouncementId), 1)
          : selectedRows.push(row.advAnnouncementId)
      "
      [attr.data-cy]="E2eLocators.ADMIN_ANNOUNCEMENT_ROW"
    ></mat-row>
    <onsip-table-shelf *matRowDef="let row; columns: ['expanded']"></onsip-table-shelf>
    <div *matNoDataRow class="no-data-row">
      @if (search.value && dataSource.data && dataSource.data.length) {
      <span>
        {{ "ONSIP_I18N.NO_RESULTS" | translate }}
      </span>
      } @else {
      <span
        translate
        [translateParams]="{ value: 'ONSIP_I18N.ANNOUNCEMENTS' | translate | lowercase }"
      >
        ONSIP_I18N.YOU_HAVENT_ADDED_ANY_VALUE_YET
      </span>
      }
    </div>
  </onsip-table-two>
  <mat-paginator
    onsip-paginator-primary-icon
    showFirstLastButtons
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
  >
  </mat-paginator>
  } @else {
  <onsip-announcements-empty-data
    [viewsLink]="views.ADMIN_ADV_ANNOUNCEMENTS_SETUP"
    [pricingText]="pricingText"
  ></onsip-announcements-empty-data>
  }
  <div class="contact-tagline">
    <span>
      {{ "ONSIP_I18N.NEED_HELP_CONTACT_OUR" | translate }}
      <a [routerLink]="views.CONTACT_SUPPORT" class="primary-500">
        {{ "ONSIP_I18N.SUPPORT_TEAM" | translate | titlecase }}
      </a>
    </span>
  </div>
</onsip-loading-container>
